module.exports = __webpack_public_path__ + "img/logo-rb.a4ceb07c.png";